export const CoverTypeValue = Object.freeze({
  HOSPITAL_ONLY: 'hospital',
  EXTRAS_ONLY: 'extras',
  HOSPITAL_AND_EXTRAS: 'both',
});

export default CoverTypeValue;